import type { FilterRuleModel } from '@/shared/generated'

export const isProductFilter = (filter: FilterRuleModel) =>
	filter.name !== 'competitor_name'
export const isCompetitorFilter = (filter: FilterRuleModel) =>
	filter.name === 'competitor_name'
